import {MarkdownRenderer} from '@github-ui/copilot-markdown'
import {ThinkingBlock} from '../ThinkingBlock'
import type {AssistantTextItem} from '../../../types/events'

export function AssistantText({item}: {item: AssistantTextItem}) {
  return (
    <>
      {item.reasoningText && <ThinkingBlock reasoningText={item.reasoningText} />}
      {item.content && (
        <div className="d-flex flex-row flex-items-start gap-2 px-1 mb-2">
          <div className="flex-1 min-width-0">
            <MarkdownRenderer markdown={item.content} />
          </div>
        </div>
      )}
    </>
  )
}
